export default {
  path: '/club',
  name: 'club',
  redirect: '/club/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/club'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/club/info'),
      meta: { requiresAuth: true }
    },
    {
      path: 'squadDetail',
      component: () => import('@/views/squad/Detail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'setting',
      component: () => import('@/views/club/setting'),
      meta: { requiresAuth: true }
    },
  ]
}
